import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { CreateJobRequest, IJob } from "../models/Job";
// import { ISetting, ISettingsResponse } from "../models/Setting";

export default function useJobMutations() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  // invalidateQueries only refetches mounted queries; refetchQueries on a bare prefix also
  // refetched every cached vehicle/lead the user had visited, which made Create Job crawl.
  const create = useMutation(
    (job: CreateJobRequest) => post(`/job`, job),
    {
      onSuccess: (_, job) => {
        queryClient.invalidateQueries(["jobs"]);
        if (job.leadId) queryClient.invalidateQueries(["lead", job.leadId]);
        if (job.vehicleId) queryClient.invalidateQueries(["vehicles", job.vehicleId]);
      },
    }
  );

  const update = useMutation(
    (job: IJob) => put(`/job/${job.id}`, job),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["jobs"]);
      },
    }
  );

  const remove = useMutation(
    (job: Pick<IJob, "id" | "leadId">) => del(`/job/${job.id}`),
    {
      // Callers invalidate the vehicle they're showing - IJob doesn't carry its vehicleId.
      onSuccess: (_, job) => {
        queryClient.invalidateQueries(["jobs"]);
        if (job.leadId) queryClient.invalidateQueries(["lead", job.leadId]);
      },
    }
  );

  return {
    create,
    update,
    remove
  };
}
